import React, { useEffect, useState } from "react";
import FilledButton from "../InterstellrComponents/FilledButton";
import CommonTextField from "../InterstellrComponents/CommonTextField";
import axios from "axios";
import { CREATE_USER } from "../Routes";
import { generateURLOptions } from "../URLOptions";
import { IoEye, IoEyeOutline } from "react-icons/io5";

const AddPersonModal = ({ isOpen, onClose, profile }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const createUser = async () => {
    if (password !== confirmPassword) {
      return alert("Passwords do not match");
    }

    try {
      const response = await axios.post(
        CREATE_USER,
        {
          companyId: profile?.company_id?._id,
          firstName,
          lastName,
          email,
          phone,
          password,
        },
        {
          headers: generateURLOptions(),
        }
      );

      if (response.data?.success === false) {
        return alert(response.data?.message ?? "");
      }

      onClose();
    } catch (error) {
      console.log("Create User Error:", error);
      return alert("Failed to create user");
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setFirstName("");
      setLastName("");
      setEmail("");
      setPhone("");
      setPassword("");
      setConfirmPassword("");
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300">
      <div className="bg-white rounded-xl w-full max-w-sm mx-4 p-6 shadow-xl transform transition-all duration-300 scale-100">
        <div className="flex flex-col items-start">
          <h4 className="text-xl font-semibold text-left">
            Add Person to Organisation
          </h4>
          <p className="text-sm text-left text-black mb-4">
            Fill out the details below to create a new user.
          </p>

          <CommonTextField
            title="First Name"
            placeholder="Enter first name"
            value={firstName}
            onChange={setFirstName}
          />

          <CommonTextField
            title="Last Name"
            placeholder="Enter last name"
            value={lastName}
            onChange={setLastName}
          />

          <CommonTextField
            title="Email"
            placeholder="Enter email address"
            value={email}
            onChange={setEmail}
          />

          <CommonTextField
            title="Phone"
            placeholder="Enter phone number"
            value={phone}
            onChange={setPhone}
          />

          <CommonTextField
            title={"Password"}
            placeholder={"Password"}
            type="password"
            value={password}
            onChange={setPassword}
            showPassword={showPassword}
            suffixIcon={
              showPassword ? (
                <IoEye
                  onClick={() => setShowPassword(false)}
                  color="#5153F5"
                  className="text-2xl mr-4"
                />
              ) : (
                <IoEyeOutline
                  onClick={() => setShowPassword(true)}
                  color="#5153F5"
                  className="text-2xl mr-4"
                />
              )
            }
          />

          <CommonTextField
            title={"Confirm Password"}
            placeholder={"Confirm Password"}
            type="password"
            value={confirmPassword}
            onChange={setConfirmPassword}
            showPassword={showConfirm}
            suffixIcon={
              showConfirm ? (
                <IoEye
                  onClick={() => setShowConfirm(false)}
                  color="#5153F5"
                  className="text-2xl mr-4"
                />
              ) : (
                <IoEyeOutline
                  onClick={() => setShowConfirm(true)}
                  color="#5153F5"
                  className="text-2xl mr-4"
                />
              )
            }
          />

          <FilledButton text="Create User" onPress={createUser} marginTop={8} />

          <button
            onClick={onClose}
            className="w-full text-sm bg-gray-200 text-gray-800 py-2 px-4 rounded-full mt-2 hover:bg-gray-300 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddPersonModal;
